<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Parking Pass View</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm status-view-edit">
                        <div class="col-md-4">
                            <label>Status</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <span *ngIf="parkingPassService.parkingPassInParkingPassModal.status === 'approved'">
                                <span *ngIf="parkingPassService.parkingPassInParkingPassModal.timeRelatedStatus === 'current'"
                                      class="label label-current">
                                    Current
                                </span>
                                <span *ngIf="parkingPassService.parkingPassInParkingPassModal.timeRelatedStatus === 'future'"
                                      class="label label-future">
                                    Future
                                </span>
                                <span *ngIf="parkingPassService.parkingPassInParkingPassModal.timeRelatedStatus === 'past'"
                                      class="label label-past">
                                    Past
                                </span>
                            </span>
                            <span *ngIf="parkingPassService.parkingPassInParkingPassModal.status === 'pending'"
                                  class="label label-pending">
                                Pending
                            </span>
                            <span *ngIf="parkingPassService.parkingPassInParkingPassModal.status === 'declined'"
                                  class="label label-declined">
                                Declined
                            </span>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.buildingName}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.suiteNumber}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Resident</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.residentFullName}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Parking Lot</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.bookingParkingLot ? parkingPassService.parkingPassInParkingPassModal.bookingParkingLot.name : ''}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Visitor</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.visitorFullName}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Visitor's Vehicle Make/Model</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.visitorVehicle}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Visitor's License Plate</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.visitorLicensePlate}}
                        </div>
                    </div>

                    <div class="row m-b-sm"
                         *ngFor="let pass of parkingPassService.parkingPassInParkingPassModal.bookingPassTypes; let index = index;">
                        <div class="col-md-2">
                            <label *ngIf="index == 0">Passes</label>
                        </div>
                        <div class="col-md-10 fourteenPixelText display-inline">
                            <div class="summary-pass-type-name">{{pass.passTypeName}}</div>
                            {{pass.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}} -
                            {{pass.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Created On</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.createdAt | mccDate: true : undefined }}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Created By</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{parkingPassService.parkingPassInParkingPassModal.createdBy}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-view/parking-pass-view.component.html